import Vue from 'vue';
import Vuex from 'vuex';

import authModule from './auth';
import dictModule from './dict';
import settingsModule from './settings';
import weekendsModule from './weekends';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth: authModule,
    dict: dictModule,
    settings: settingsModule,
    weekends: weekendsModule,
  },
});

export default store;
